<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

import PFBaseModal from "@/components/common/modal/PFBaseModal.vue";
import PartnerLevelPlatinumContentComponent from "@/components/common/PartnerLevelPlatinumContentComponent";
import PartnerLevelGoldContentComponent from "@/components/common/PartnerLevelGoldContentComponent";
import PartnerLevelSilverContentComponent from "@/components/common/PartnerLevelSilverContentComponent";
import PartnerLevelKeyGategoriesListComponent from "@/components/common/PartnerLevelKeyGategoriesListComponent";

const { t } = useI18n();
const store = useStore();
/**
 * Gold and Silver levels of a partner are identified by the countries in the collections of goldCountries and silverCountries.
 * If a partner has only the Platinum level in the profile data and does not have any countries in the collections (like: goldCountries, silverCountries, uvarPlatinumCountries), it means that it is a Platinum level partner and will be shown text that it's a strategic Platinum partner. No countries list or any additional level will be shown.
 * If a partner has countries in the uvarPlatinum collection, then the partner has a uvarPlatinum level and additionally other levels could be shown in the modal.
 */
const isSilverPartner = computed(() => store.state.partnerProfile.profileData.silverCountries?.length > 0);
const isGoldPartner = computed(() => store.state.partnerProfile.profileData.goldCountries?.length > 0);
const isUvarPlatinumPartner = computed(() => store.state.partnerProfile.profileData.uvarPlatinumCountries?.length > 0);
const isSapPlatinumPartner = computed(
  () => store.state.partnerProfile.profileData.level === "PLATINUM" && !isUvarPlatinumPartner.value
);
const partnerLevels = computed(() => {
  return [isSilverPartner.value, isGoldPartner.value, isUvarPlatinumPartner.value].filter(Boolean);
});

const companyName = computed(() => store.state.partnerProfile.profileData.name);
</script>

<template>
  <PFBaseModal :modalHeaderText="t('sap.partner.level', partnerLevels.length > 1 ? 2 : 1)">
    <div class="body-s-size">
      <PartnerLevelPlatinumContentComponent
        v-if="isSapPlatinumPartner || isUvarPlatinumPartner"
        :companyName="companyName"
        :isSapPlatinumPartner
      />
      <PartnerLevelKeyGategoriesListComponent
        v-if="(isSilverPartner||isGoldPartner) && !isSapPlatinumPartner"
      />
      <PartnerLevelGoldContentComponent v-if="isGoldPartner && !isSapPlatinumPartner" />
      <PartnerLevelSilverContentComponent v-if="isSilverPartner && !isSapPlatinumPartner" />
    </div>
  </PFBaseModal>
</template>
